var _defs, _path, _path2, _path3, _circle, _circle2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M256 45.268a210.73 210.73 0 00-210.73 210.73A210.73 210.73 0 00256 466.728a210.73 210.73 0 00210.73-210.73A210.73 210.73 0 00256 45.268zm0 111.84a98.889 98.889 0 0198.889 98.889A98.889 98.889 0 01256 354.886a98.889 98.889 0 01-98.889-98.889A98.889 98.889 0 01256 157.108z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc831",
    d: "M455.38 151.67c-315.14 251.77-157.57 125.89 0 0zm0 0l-182.16.07c50.16 8.227 88.436 51.768 88.436 104.26a105.658 105.658 0 01-26.666 70.02l-90.34 154.7c3.758.188 7.54.285 11.344.284 124.26 0 225-100.74 225-225 0-37.655-9.265-73.14-25.617-104.33z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d41a1a",
    d: "M256 31c-80.893 0-151.8 42.696-191.46 106.77l87.802 138.28c.407 6.581-2.001-19.578-2.006-20.051 0-58.355 47.306-105.66 105.66-105.66 5.478.044 10.946.514 16.35 1.405l183.03-.07c-37.61-71.73-112.77-120.67-199.38-120.67zM64.52 137.82c-54.566 261.01-27.283 130.5 0 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0fa15f",
    d: "M64.543 137.77C43.283 172.126 31 212.624 31 256c0 120.46 94.663 218.81 213.66 224.72L335 326.02a105.661 105.661 0 01-78.996 35.641c-50.591-.042-94.054-35.938-103.65-85.61z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 105.66,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 87.188,
    fill: "#367bf0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.52 145.28l82.559 129.44 31.779-41.824-114.34-87.615zm366.24 12.965l-170.86.098 18.789 48.89 152.07-48.987zm-164.34 152.51l-33.041 155.74 84.555-144.81-51.514-10.93z",
    clipPath: "url(#a)",
    opacity: 0.1,
    transform: "translate(-17.332 -17.332) scale(1.0677)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.ac1587b88d348152cc39bff35a4e344a.svg";
export { ForwardRef as ReactComponent };